// @flow
import axios from 'axios';
import CropHandler from './CropHandler';
import { loader } from '../../../layout/loader';

/**
 * Universal Media Uploader
 */
export default class UploadHandler {
    constructor(filterName: string, imageRef = null, route = null, image = null, id = null, hash = null) {
        this.filterName = filterName.toLowerCase();
        this.ref = imageRef;
        this.route = route;
        this.image = image;
        this.id = id;
        this.cropValues = null;
        this.hash = hash;
        this.CropHandler = new CropHandler(imageRef, filterName.toLowerCase());
    }

    /**
     * Generate route for POST/PATCH media
     * @returns {*}
     */
    generateRoute() {
        if (window.fos === undefined) {
            this.route = `http://localhost:9009/${this.filterName}`;
        } else {
            if (this.hash !== null) {
                this.route = Routing.generate('reborn_media.upload', {
                    context: this.filterName,
                    hash: this.hash,
                });
                return false;
            }

            switch (this.filterName) {
                case ('user_avatar'):
                    this.route = Routing.generate('app_user.upload_avatar', {
                        id: this.id,
                    });
                    break;
                case ('user_logo_color'):
                case ('user_logo_black'):
                case ('user_logo_white'):
                    this.route = Routing.generate('app_user.upload_logo', {
                        id: this.id,
                        type: this.filterName,
                    });
                    break;
                case ('client_logo'):
                    this.route = Routing.generate('app_client.upload_logo', {
                        id: this.id,
                    });
                    break;
                default:
                    this.route = Routing.generate('app_estimation.media_upload', {
                        media_type: this.filterName,
                        ref: this.ref,
                    });
                    break;
            }
        }
    }

    /**
     * Generate route for DELETE media
     * @returns {*}
     */
    generateDeleteRoute() {
        if (window.fos === undefined) {
            this.route = `http://localhost:9009/${this.filterName}`;
        } else {
            if (this.hash !== null) {
                this.route = Routing.generate('reborn_media.upload_delete', {
                    context: this.filterName,
                    hash: this.hash,
                });
                return false;
            }
            switch (this.filterName) {
                case ('user_avatar'):
                    this.route = Routing.generate('app_user.delete_avatar', {
                        id: this.id,
                    });
                    break;
                case ('user_logo_color'):
                case ('user_logo_black'):
                case ('user_logo_white'):
                    this.route = Routing.generate('app_user.delete_logo', {
                        id: this.id,
                        type: this.filterName,
                    });
                    break;
                case ('client_logo'):
                    this.route = Routing.generate('app_client.delete_logo', {
                        id: this.id,
                    });
                    break;
                default:
                    // this.route = Routing.generate('app_estimation.media_upload', {
                    //     "media_type": this.filterName,
                    //     "ref": this.ref
                    // });
                    break;
            }
        }
    }

    /**
     * Set FormData Element to image prop
     * @param image - FormData Element
     * @returns {*}
     */
    setNewImageToSend(image) {
        this.image = image;
    }

    setLoaderVisibility(value, response) {
        console.log(response)
        if (window.loader !== undefined) {
            value ? loader.show() : loader.hide(response);
        }
    }

    /**
     * POST media action
     * @param progressCallback
     * @param successCallback
     * @param errorCallback
     */
    postImage(progressCallback, successCallback, errorCallback) {
        const _this = this;
        this.generateRoute();
        // this.setLoaderVisibility(true);
        axios.post(this.route, this.image, {
            onUploadProgress: (progressEvent) => {
                const data = {
                    percent: (progressEvent.loaded * 100) / progressEvent.total,
                    size: progressEvent.total,
                    uploaded: progressEvent.loaded,
                };
                if (progressCallback !== null) progressCallback(data);
            }
        })
            .then((response) => {
                // this.setLoaderVisibility(false);
                if (response.data.status === 'error') {
                    if (errorCallback !== undefined) errorCallback('error')
                } else {
                    if (successCallback !== undefined) successCallback(response.data);
                }
            })
            .catch((response) => {
                _this.setLoaderVisibility(false, response);
                if (errorCallback !== null) errorCallback();
            });
    }

    deleteImage(successCallback) {
        const _this = this;
        this.generateDeleteRoute();
        this.setLoaderVisibility(true);
        
        axios.delete(this.route)
            .then((response) => {
                _this.setLoaderVisibility(false, response);
                if (response.data.status === 'error') {
                    alert('error');
                } else if (successCallback !== undefined) {
                    successCallback(response.data, response);
                }
            })
            .catch((response) => {
                _this.setLoaderVisibility(false, response);
            });
    }

    getCropValues(callbackFunc) {
        this.cropValues = this.CropHandler.getValues(callbackFunc);
    }

    update(filter, reference) {
        this.filter = filter;
        this.ref = reference;
        this.CropHandler.update(reference, filter);
    }
}



// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/helpers/UploadHandler.js